export const CLIENT_STATUSES = [
  {
    value: "inactive_dormant",
    label: "Inactive / Dormant",
    labelKey: "pilotStatuses.client.inactive_dormant"
  },
  {
    value: "active_account",
    label: "Active Account",
    labelKey: "pilotStatuses.client.active_account"
  },
  {
    value: "strategic_key_account",
    label: "Strategic / Key Account",
    labelKey: "pilotStatuses.client.strategic_key_account"
  },
  {
    value: "blacklisted_excluded",
    label: "Blacklisted / Excluded",
    labelKey: "pilotStatuses.client.blacklisted_excluded"
  }
];

export const CLIENT_STATUS_LABELS = CLIENT_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const CLIENT_STATUS_LABEL_KEYS = CLIENT_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const CLIENT_STATUS_COLORS = {
  inactive_dormant: "gray",
  active_account: "green",
  strategic_key_account: "purple",
  blacklisted_excluded: "red",
};

// Contact status values for client contact lifecycle.
export const CONTACT_STATUSES = [
  {
    value: "new_lead_pool",
    label: "New Lead Pool",
    labelKey: "pilotStatuses.contact.new_lead_pool"
  },
  {
    value: "lead_to_qualify",
    label: "Lead to Qualify",
    labelKey: "pilotStatuses.contact.lead_to_qualify"
  },
  {
    value: "cold_prospect",
    label: "Cold Prospect",
    labelKey: "pilotStatuses.contact.cold_prospect"
  },
  {
    value: "warm_prospect_opportunity",
    label: "Warm Prospect / Opportunity",
    labelKey: "pilotStatuses.contact.warm_prospect_opportunity"
  },
  {
    value: "active_client",
    label: "Active Client",
    labelKey: "pilotStatuses.contact.active_client"
  },
  {
    value: "lost_dropped",
    label: "Lost / Dropped",
    labelKey: "pilotStatuses.contact.lost_dropped"
  }
];

export const CONTACT_STATUS_LABELS = CONTACT_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const CONTACT_STATUS_LABEL_KEYS = CONTACT_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const CONTACT_STATUS_COLORS = {
  new_lead_pool: "blue",
  lead_to_qualify: "cyan",
  cold_prospect: "gray",
  warm_prospect_opportunity: "yellow",
  active_client: "green",
  lost_dropped: "red",
};

export const NEED_STATUSES = [
  {
    value: "open_early_stage",
    label: "Open – Early stage",
    labelKey: "pilotStatuses.need.open_early_stage"
  },
  {
    value: "open_rfp_received",
    label: "Open – RFP received",
    labelKey: "pilotStatuses.need.open_rfp_received"
  },
  {
    value: "closed_need_closed",
    label: "Closed – Need closed",
    labelKey: "pilotStatuses.need.closed_need_closed"
  },
  {
    value: "abandoned",
    label: "Abandoned",
    labelKey: "pilotStatuses.need.abandoned"
  },
  {
    value: "postponed",
    label: "Postponed",
    labelKey: "pilotStatuses.need.postponed"
  },
  {
    value: "reopened",
    label: "Reopened",
    labelKey: "pilotStatuses.need.reopened"
  }
];

export const NEED_STATUS_LABELS = NEED_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const NEED_STATUS_LABEL_KEYS = NEED_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const NEED_STATUS_COLORS = {
  open_early_stage: "blue",
  open_rfp_received: "purple",
  closed_need_closed: "green",
  abandoned: "red",
  postponed: "gray",
  reopened: "orange"
};

export const CONSULTANT_STATUSES = [
  { value: "active", label: "Active", labelKey: "pilotStatuses.consultant.active" },
  { value: "bench", label: "Bench", labelKey: "pilotStatuses.consultant.bench" },
  { value: "prospect", label: "Prospect", labelKey: "pilotStatuses.consultant.prospect" },
  { value: "inactive", label: "Inactive", labelKey: "pilotStatuses.consultant.inactive" }
];

export const CONSULTANT_STATUS_LABELS = CONSULTANT_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const CONSULTANT_STATUS_LABEL_KEYS = CONSULTANT_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

// Consultant staffing status (backend: staffing_status / staffingStatus)
export const CONSULTANT_STAFFING_STATUSES = [
  {
    value: "active",
    label: "Internal (active)",
    labelKey: "pilotStatuses.consultantStaffing.active"
  },
  {
    value: "recruiting",
    label: "Talent pool (recruiting)",
    labelKey: "pilotStatuses.consultantStaffing.recruiting"
  },
  {
    value: "unavailable",
    label: "Unavailable",
    labelKey: "pilotStatuses.consultantStaffing.unavailable"
  },
  {
    value: "talent_pool",
    label: "Talent Pool",
    labelKey: "pilotStatuses.consultantStaffing.talentPool"
  },
  {
    value: "between_assignments",
    label: "Between Assignments",
    labelKey: "pilotStatuses.consultantStaffing.betweenAssignments"
  },
  {
    value: "match_in_progress",
    label: "Match in Progress",
    labelKey: "pilotStatuses.consultantStaffing.matchInProgress"
  },
  {
    value: "presented_to_client",
    label: "Presented to Client",
    labelKey: "pilotStatuses.consultantStaffing.presentedToClient"
  },
  {
    value: "signed",
    label: "Signed",
    labelKey: "pilotStatuses.consultantStaffing.signed"
  },
  {
    value: "rejected",
    label: "Rejected",
    labelKey: "pilotStatuses.consultantStaffing.rejected"
  },
  {
    value: "tender_abandoned",
    label: "Tender Abandoned",
    labelKey: "pilotStatuses.consultantStaffing.tenderAbandoned"
  }
];

export const CONSULTANT_STAFFING_STATUS_LABELS =
  CONSULTANT_STAFFING_STATUSES.reduce((acc, s) => {
    acc[s.value] = s.label;
    return acc;
  }, {});

export const CONSULTANT_STAFFING_STATUS_LABEL_KEYS =
  CONSULTANT_STAFFING_STATUSES.reduce((acc, s) => {
    acc[s.value] = s.labelKey;
    return acc;
  }, {});

export const CONSULTANT_STAFFING_STATUS_COLORS = {
  active: "green",
  recruiting: "blue",
  unavailable: "gray",
  talent_pool: "cyan",
  between_assignments: "orange",
  match_in_progress: "yellow",
  presented_to_client: "purple",
  signed: "green",
  rejected: "red",
  tender_abandoned: "gray",
  departure: "gray"
};

export const MATCH_ASSIGNMENT_STATUSES = [
  {
    value: "POTENTIAL",
    label: "Potential",
    labelKey: "pilotStatuses.matchAssignment.potential"
  },
  {
    value: "PROPOSED",
    label: "Proposed",
    labelKey: "pilotStatuses.matchAssignment.proposed"
  },
  {
    value: "CONFIRMED",
    label: "Confirmed",
    labelKey: "pilotStatuses.matchAssignment.confirmed"
  },
  {
    value: "ACTIVE",
    label: "Active",
    labelKey: "pilotStatuses.matchAssignment.active"
  },
  {
    value: "COMPLETED",
    label: "Completed",
    labelKey: "pilotStatuses.matchAssignment.completed"
  },
  {
    value: "CANCELLED",
    label: "Cancelled",
    labelKey: "pilotStatuses.matchAssignment.cancelled"
  },
  {
    value: "LOST",
    label: "Lost",
    labelKey: "pilotStatuses.matchAssignment.lost"
  }
];

export const MATCH_ASSIGNMENT_STATUS_LABELS = MATCH_ASSIGNMENT_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const MATCH_ASSIGNMENT_STATUS_LABEL_KEYS = MATCH_ASSIGNMENT_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const MATCH_PURCHASE_ORDER_STATUSES = [
  {
    value: "PENDING",
    label: "Pending",
    labelKey: "pilotStatuses.matchPurchaseOrder.pending"
  },
  {
    value: "RECEIVED",
    label: "Received",
    labelKey: "pilotStatuses.matchPurchaseOrder.received"
  },
  {
    value: "NOT_REQUIRED",
    label: "Not required",
    labelKey: "pilotStatuses.matchPurchaseOrder.not_required"
  },
  {
    value: "CANCELLED",
    label: "Cancelled",
    labelKey: "pilotStatuses.matchPurchaseOrder.cancelled"
  }
];

export const MATCH_PURCHASE_ORDER_STATUS_LABELS =
  MATCH_PURCHASE_ORDER_STATUSES.reduce((acc, s) => {
    acc[s.value] = s.label;
    return acc;
  }, {});

export const MATCH_PURCHASE_ORDER_STATUS_LABEL_KEYS =
  MATCH_PURCHASE_ORDER_STATUSES.reduce((acc, s) => {
    acc[s.value] = s.labelKey;
    return acc;
  }, {});

// Match workflow pipeline statuses (Phase 3 – Point 24)
export const MATCH_WORKFLOW_STATUSES = [
  {
    value: "VALIDATED",
    label: "Validated",
    labelKey: "pilotStatuses.matchWorkflow.validated"
  },
  {
    value: "SENT_TO_CLIENT",
    label: "Sent to Client",
    labelKey: "pilotStatuses.matchWorkflow.sent_to_client"
  },
  {
    value: "INTERVIEW",
    label: "Interview",
    labelKey: "pilotStatuses.matchWorkflow.interview"
  },
  {
    value: "AWAITING_FEEDBACK",
    label: "Awaiting Feedback",
    labelKey: "pilotStatuses.matchWorkflow.awaiting_feedback"
  },
  {
    value: "WON",
    label: "Won",
    labelKey: "pilotStatuses.matchWorkflow.won"
  }
];

export const MATCH_WORKFLOW_EXIT_STATUSES = [
  {
    value: "WITHDRAWN",
    label: "Withdrawn",
    labelKey: "pilotStatuses.matchWorkflow.withdrawn"
  },
  {
    value: "REJECTED",
    label: "Rejected",
    labelKey: "pilotStatuses.matchWorkflow.rejected"
  }
];

export const MATCH_WORKFLOW_STATUS_LABELS = [
  ...MATCH_WORKFLOW_STATUSES,
  ...MATCH_WORKFLOW_EXIT_STATUSES
].reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const MATCH_WORKFLOW_STATUS_LABEL_KEYS = [
  ...MATCH_WORKFLOW_STATUSES,
  ...MATCH_WORKFLOW_EXIT_STATUSES
].reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const MATCH_WORKFLOW_STATUS_COLORS = {
  VALIDATED: "blue",
  SENT_TO_CLIENT: "purple",
  INTERVIEW: "cyan",
  AWAITING_FEEDBACK: "orange",
  WON: "green",
  WITHDRAWN: "gray",
  REJECTED: "red"
};

export const INTERVIEW_STATUSES = [
  {
    value: "scheduled",
    label: "Scheduled",
    labelKey: "pilotStatuses.interview.scheduled"
  },
  {
    value: "completed",
    label: "Completed",
    labelKey: "pilotStatuses.interview.completed"
  },
  {
    value: "cancelled",
    label: "Cancelled",
    labelKey: "pilotStatuses.interview.cancelled"
  }
];

export const INTERVIEW_STATUS_LABELS = INTERVIEW_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const INTERVIEW_STATUS_LABEL_KEYS = INTERVIEW_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const getStatusLabel = (t, labelKeys, fallbackLabels, value) => {
  if (!value) return "";
  const key = labelKeys?.[value];
  if (key && typeof t === "function") {
    const translated = t(key);
    if (translated && translated !== key) {
      return translated;
    }
  }
  return fallbackLabels?.[value] || value;
};

// ASAP Partners statuses
export const PARTNERS_POOL_STATUSES = [
  { value: "active", label: "Active", labelKey: "partnersStatuses.pool.active" },
  { value: "archived", label: "Archived", labelKey: "partnersStatuses.pool.archived" },
];

export const PARTNERS_POOL_STATUS_LABELS = PARTNERS_POOL_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const PARTNERS_POOL_STATUS_LABEL_KEYS = PARTNERS_POOL_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const PARTNERS_POOL_STATUS_COLORS = {
  active: "green",
  archived: "gray",
};

export const PARTNERS_POOL_MEMBER_STATUSES = [
  { value: "active", label: "Active", labelKey: "partnersStatuses.poolMember.active" },
  { value: "new_to_add", label: "New", labelKey: "partnersStatuses.poolMember.new_to_add" },
  { value: "removed", label: "Removed", labelKey: "partnersStatuses.poolMember.removed" },
];

export const PARTNERS_POOL_MEMBER_STATUS_LABELS = PARTNERS_POOL_MEMBER_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const PARTNERS_POOL_MEMBER_STATUS_LABEL_KEYS = PARTNERS_POOL_MEMBER_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const PARTNERS_POOL_MEMBER_STATUS_COLORS = {
  active: "green",
  new_to_add: "blue",
  removed: "red",
};

export const PARTNERS_MISSION_STATUSES = [
  { value: "draft", label: "Draft", labelKey: "partnersStatuses.mission.draft" },
  { value: "sent", label: "Sent", labelKey: "partnersStatuses.mission.sent" },
  { value: "active", label: "Active", labelKey: "partnersStatuses.mission.active" },
  { value: "filled", label: "Filled", labelKey: "partnersStatuses.mission.filled" },
  { value: "closed", label: "Closed", labelKey: "partnersStatuses.mission.closed" },
  { value: "expired", label: "Expired", labelKey: "partnersStatuses.mission.expired" },
];

export const PARTNERS_MISSION_STATUS_LABELS = PARTNERS_MISSION_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const PARTNERS_MISSION_STATUS_LABEL_KEYS = PARTNERS_MISSION_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const PARTNERS_MISSION_STATUS_COLORS = {
  draft: "gray",
  sent: "blue",
  active: "green",
  filled: "purple",
  closed: "red",
  expired: "orange",
};

// Partner Links
export const PARTNERS_PARTNER_LINK_STATUSES = [
  { value: "active", label: "Active", labelKey: "partnersStatuses.partnerLink.active" },
  { value: "suspended", label: "Suspended", labelKey: "partnersStatuses.partnerLink.suspended" },
  { value: "removed", label: "Removed", labelKey: "partnersStatuses.partnerLink.removed" },
];

export const PARTNERS_PARTNER_LINK_STATUS_LABELS = PARTNERS_PARTNER_LINK_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const PARTNERS_PARTNER_LINK_STATUS_LABEL_KEYS = PARTNERS_PARTNER_LINK_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.labelKey;
  return acc;
}, {});

export const PARTNERS_PARTNER_LINK_STATUS_COLORS = {
  active: "green",
  suspended: "orange",
  removed: "red",
};

// Incoming Missions
export const PARTNERS_INCOMING_STATUSES = [
  { value: "pending", label: "Pending", labelKey: "partnersStatuses.incoming.pending" },
  { value: "accepted", label: "Accepted", labelKey: "partnersStatuses.incoming.accepted" },
  { value: "declined", label: "Declined", labelKey: "partnersStatuses.incoming.declined" },
  { value: "completed", label: "Completed", labelKey: "partnersStatuses.incoming.completed" },
];

export const PARTNERS_INCOMING_STATUS_LABELS = PARTNERS_INCOMING_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const PARTNERS_INCOMING_STATUS_COLORS = {
  pending: "yellow",
  accepted: "green",
  declined: "red",
  completed: "purple",
};

// Candidate Submissions
export const PARTNERS_SUBMISSION_STATUSES = [
  { value: "submitted", label: "Submitted", labelKey: "partnersStatuses.submission.submitted" },
  { value: "scored", label: "Scored", labelKey: "partnersStatuses.submission.scored" },
  { value: "shortlisted", label: "Shortlisted", labelKey: "partnersStatuses.submission.shortlisted" },
  { value: "rejected", label: "Rejected", labelKey: "partnersStatuses.submission.rejected" },
  { value: "positioned", label: "Positioned", labelKey: "partnersStatuses.submission.positioned" },
];

export const PARTNERS_SUBMISSION_STATUS_LABELS = PARTNERS_SUBMISSION_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const PARTNERS_SUBMISSION_STATUS_COLORS = {
  submitted: "blue",
  scored: "cyan",
  shortlisted: "green",
  rejected: "red",
  positioned: "purple",
};

// --- Portal redesign: canonical colorScheme maps (consumed by <StatusBadge/>).
// Hoisted here so the dot colours stay consistent across surfaces (previously
// duplicated as per-file local maps during the Corporate Azure migration).

// Consultant lifecycle (top-level) status — distinct from the staffing map above.
export const CONSULTANT_LIFECYCLE_STATUS_COLORS = {
  active: "green",
  bench: "orange",
  prospect: "blue",
  inactive: "gray",
};

// Consultant portal-access status.
export const PORTAL_ACCESS_STATUS_COLORS = {
  active: "green",
  invited: "blue",
  disabled: "red",
  inactive: "gray",
};

// Assignment status (uppercase keys, as stored by the backend).
export const ASSIGNMENT_STATUS_COLORS = {
  ACTIVE: "green",
  CONFIRMED: "blue",
  COMPLETED: "gray",
  PROPOSED: "orange",
  POTENTIAL: "purple",
  CANCELLED: "red",
  LOST: "red",
};

// Purchase-order status (uppercase keys).
export const PURCHASE_ORDER_STATUS_COLORS = {
  PENDING: "orange",
  RECEIVED: "green",
  NOT_REQUIRED: "gray",
  CANCELLED: "red",
};

// Interview status (lowercase keys, as stored by the backend).
export const INTERVIEW_STATUS_COLORS = {
  completed: "green",
  scheduled: "blue",
  cancelled: "red",
};

// Consultant contract type (visual-only; no semantic status, distinct hues).
export const CONTRACT_TYPE_COLORS = {
  permanent_contract: "green",
  freelance: "blue",
  subcontracting: "orange",
  umbrella_company: "purple",
};

// Pilot task status / priority.
export const TASK_STATUS_COLORS = {
  open: "blue",
  in_progress: "orange",
  done: "green",
  cancelled: "gray",
};

export const TASK_PRIORITY_COLORS = {
  high: "red",
  normal: "blue",
  low: "gray",
};

// Partner consultant-proposal status.
export const PROPOSAL_STATUS_COLORS = {
  pending: "orange",
  accepted: "green",
  declined: "red",
};

